import { useLang } from '../LangContext';

export default function About() {
  const { t } = useLang();

  return (
    <section id="about" className="about">
      <div className="section-container">
        <div className="about-image">
          <img
            src="https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=700&q=80"
            alt="Many kids playing together at school"
          />
          <div className="about-img-sticker">
            <span>{t.aboutSticker[0]}</span>
            {t.aboutSticker[1]}
            <br />
            {t.aboutSticker[2]}
          </div>
        </div>

        <div className="about-content">
          <span className="section-tag">{t.aboutTag}</span>
          <h2>{t.aboutH2}</h2>
          <p>{t.aboutP}</p>
          <div className="mv-cards">
            <div className="mv-card orange">
              <div className="card-icon">🎯</div>
              <h3>{t.missionTitle}</h3>
              <p>{t.missionP}</p>
            </div>
            <div className="mv-card cyan">
              <div className="card-icon">🌈</div>
              <h3>{t.visionTitle}</h3>
              <p>{t.visionP}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
